import { Button } from '@consta/uikit/Button'
import { IconGeoWindowB } from '@core/icons'
import type { TabType } from '@library/model'
import { constructBrowserTabUrl, getIconByType, isCoreTab } from '@library/model'
import type { FC } from 'react'
import { Link, useParams } from 'react-router-dom'

import { ButtonBlock } from './ButtonBlock'
import { BROWSER_TABS_BUTTONS, CORE_TABS_BUTTONS } from './constants'
import css from './CreateTab.css'

type CreateTabProps = {
  createTab: (tabType: TabType) => void
}

export const CreateTab: FC<CreateTabProps> = ({ createTab }) => {
  const { projectId = '' } = useParams()

  return (
    <main className={css.container} data-testid="create-tab-wiring">
      <div className={css.content}>
        <IconGeoWindowB className={css.icon} view="ghost" />
        <ButtonBlock title="Выберите тип окна для создания вкладки" tabs={CORE_TABS_BUTTONS}>
          {tab => {
            return (
              <Button
                data-testid={`create-tab-${tab.type}`}
                className={css.button}
                width="full"
                size="s"
                iconSize="s"
                view="ghost"
                iconLeft={getIconByType(tab.type)}
                label={tab.label}
                onClick={() => {
                  if (isCoreTab(tab.type)) {
                    createTab(tab.type)
                  }
                }}
              />
            )
          }}
        </ButtonBlock>
        <ButtonBlock
          title="Откройте модуль (работа в отдельной вкладке браузера)"
          tabs={BROWSER_TABS_BUTTONS}>
          {tab => {
            return (
              <Link to={constructBrowserTabUrl(tab.type, projectId)}>
                <Button
                  data-testid={`open-tab-${tab.type}`}
                  className={css.button}
                  width="full"
                  size="s"
                  iconSize="s"
                  view="ghost"
                  iconLeft={getIconByType(tab.type)}
                  label={tab.label}
                />
              </Link>
            )
          }}
        </ButtonBlock>
      </div>
    </main>
  )
}
